import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../../components/components.module';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {httpLoaderFactory} from '../../app.module';
import {CdkDrag, CdkDragHandle, DragDropModule} from '@angular/cdk/drag-drop';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppLayoutComponent } from './controller/layout/layout.component';
import { AppLayoutMenuFullComponent } from './components/layout-menu-full/layout-menu-full.component';
import { AppLayoutHeaderComponent } from './components/layout-header/layout-header.component';
import { AppLayoutUserProfileComponent } from './components/layout-user-profile/layout-user-profile.component';
import { AppRoutingModule } from '../../app-routing.module';
import { MatMenuModule} from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AppWidgetModule } from '../widgets/app.widgets.module';
@NgModule({
	declarations: [
		AppLayoutComponent,
    AppLayoutMenuFullComponent,
		AppLayoutHeaderComponent,
		AppLayoutUserProfileComponent
	],
	imports: [
		CommonModule,
		ComponentsModule,
		AppRoutingModule,
    MatMenuModule,
    MatButtonModule,
		FormsModule,
		CdkDrag,
		CdkDragHandle,
		DragDropModule,
		MatIconModule,
		CdkMenuModule,
		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
		MatListModule,
		MatDatepickerModule,
		MatDialogModule,
		MatTooltipModule,
		AppWidgetModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: httpLoaderFactory,
				deps: [HttpClient],
			},
			defaultLanguage: 'ru',
		})
	],

	exports: [
		AppLayoutComponent
	],
	providers: []
})
export class AppLayoutModule {
}
